import React from "react";
import translate from "../../services/Translation/lang";
import BonusRound from "../../img/bonus-round.png";

export default function RetailBonusRound() {
  return (
    <div className="retail-bonus-round">
      <img src={BonusRound} alt="bonus-round" className="bonus-round-image" />
      <span className="small">{translate("all_wins_doubled")}</span>
    </div>
  );
}
